import { render, staticRenderFns } from "./ReferralServiceItem.vue?vue&type=template&id=558e87df&scoped=true"
import script from "./ReferralServiceItem.vue?vue&type=script&lang=js"
export * from "./ReferralServiceItem.vue?vue&type=script&lang=js"
import style0 from "./ReferralServiceItem.vue?vue&type=style&index=0&id=558e87df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e87df",
  null
  
)

export default component.exports